module.exports = __webpack_public_path__ + "img/112@2x.97987f86.png";